import { handleResponse, requestTimeout } from "../utils";

const apiUrl = process.env.REACT_APP_API_URL;
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME;

export const reviewApi = {
  _get,
  _delete,
};

async function _get() {
  let token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);

  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  let result = await requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "reviews", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
  return result;
}

async function _delete(id) {
  let token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);

  const requestOptions = {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  let result = await requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "reviews/" + id, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
  return result;
}
